import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './period-form.hbs'
import CalendarControl from 'scoreboard/components/calendar-control'
import moment from 'moment'
import momentHelper from 'scoreboard/components/moment-helper'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import dateValidator from 'scoreboard/components/validators/date-validator'
import FormView from 'scoreboard/components/form-view'
import licenseRestriction from 'scoreboard/components//license-restriction'
import appDisplay from 'scoreboard/components/app-display'
import errorHandler from 'scoreboard/components/error-handler'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'

// custom marked-field for our date inputs that doesn't show an error message
// if you clear the text in the input and then click on the calendar control
var DateMarkedField = MarkedField.extend({
	_onBlur: function(e) {
		var clickedOnControl = $.contains(this.options.control.el,
			this._lastMouseDownEvent().target)
		if (!clickedOnControl) {
			MarkedField.prototype._onBlur.apply(this, arguments)
		}
	}
})

var PeriodForm = Backbone.View.extend({

	// this.calendar is a plain javascript object representing the calendar the
	// period is attached to

	// this.period is the period being edited, or null when creating a new period

	tagName: 'form',

	className: 'period-form',

	initialize: function(options) {
		this.period = options && options.period
		this.calendar = options && options.calendar
		var start, end
		if (this.period && this.period.id) {
			start = this.period && this.period.start
			end = this.period && this.period.end
		} else {
			var lastPeriod = _.last(this.calendar.periods)
			if (lastPeriod) {
				// default start is day after the last end date for the latest period
				start = moment(lastPeriod.end).add(1, 'days')
			} else {
				start = moment()
			}
			// default end is the start + the avgPeriodSize
			end = start.clone().add(this.calendar.avgPeriodSize, 'days')
		}
		this.startControl = new CalendarControl({
			initialValue: start,
			tooltip: false
		})
		this.endControl = new CalendarControl({
			initialValue: end,
			tooltip: false
		})
		this.markedFields = []

		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })

		this.startControl.on('change', this.formView.change.bind(this.formView))
		this.endControl.on('change', this.formView.change.bind(this.formView))
	},

	render: function() {
		this.$el.empty().append(template(this.period))
		this.$('.start-control').append(this.startControl.el)
		this.startControl.render()
		this.$('.end-control').append(this.endControl.el)
		this.endControl.render()

		// setup controls and corresponding inputs so they are sync
		_.each(['start', 'end'], function(name) {
			var control = this[name + 'Control']
			var input = this.$('.' + name + '-input')
			// Pre-fill dates if adding new periods
			input.val(momentHelper.formatNumericDate(control.getIsoDate()))
			control.on('change', function(value) {
				input.val(momentHelper.formatNumericDate(value))
				input.data('view').clearError()
			})
			input.on('change', function() {
				control.set(input.val())
			})
			this.markedFields.push(new DateMarkedField({
				el: this.$('[name=' + name + ']'),
				validator: [requiredValidator, dateValidator],
				control: control
			}).render())
		}.bind(this))

		this.markedFields.push(new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render())

		this.formView.start()

		return this
	},

	submit: function(e) {
		// #44189 if creating a new period, open a confirm prompt to warn the
		// user that this will trigger a full score recalc
		if (_.isNil(this.period)) {
			let recalcPrompt = new ConfirmPrompt({
				titleKey: 'admin.recalcScores',
				messageKey: 'admin.recalcScoresConfirm',
				confirmLabel: 'admin.recalcScores.recalculate',
				cancelLabel: 'common.cancel',
				onConfirm: () => {
					this._submit()
				}
			})
			recalcPrompt.once('cancel', () => this.trigger('close'))
			appDisplay.dialog(recalcPrompt)
		} else {
			this._submit()
		}
	},

	_submit: function() {
		var data = {
			id: this.period && this.period.id,
			label: this.$('.label-input').val(),
			start: this.startControl.getIsoDate(),
			end: this.endControl.getIsoDate()
		}

		return $.ajax({
			method: 'post',
			url: 'api/admin/calendars/' + this.calendar.id + '/periods',
			data: JSON.stringify(data),
			success: this.trigger.bind(this, 'done'),
			error: xhr => errorHandler(xhr, {
				handler: () => {
					if (xhr.responseJSON.messageCode == 'admin.licenses.error.dailyCalendar') {
						appDisplay.dialog(licenseRestriction.dailyCalendarRestriction())
						this.formView.start()
						return true
					}
				},
				formView: this.formView
			})
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields, 'remove')
		_.invokeMap([this.startControl, this.endControl, this.formView], 'remove')
	}

})

export default PeriodForm

PeriodForm.__filename__ = 'admin/calendars/period-form.js'
